/**
 * @generated SignedSource<<07ae6fb8b1b2ac064ca0ee8d442fc940>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AgentsPagesCanViewAgentDetailsFragment$data = {
  readonly agentPoolsRest: {
    readonly count: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "AgentsPagesCanViewAgentDetailsFragment";
};
export type AgentsPagesCanViewAgentDetailsFragment$key = {
  readonly " $data"?: AgentsPagesCanViewAgentDetailsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AgentsPagesCanViewAgentDetailsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AgentsPagesCanViewAgentDetailsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AgentPools",
      "kind": "LinkedField",
      "name": "agentPoolsRest",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "81147a257ae1782bc6da9b2407ac1470";

export default node;
